import React from 'react';
import { Menu, MenuItem } from '@mui/material';
import PropTypes from 'prop-types';
import c from 'classnames';

import './_actionMenu.scss';

const ActionMenu = ({ anchorEl, actions, handleClose, className, type = 'default', alignLeft, style }) => {
  const actionMenuClass = c('actionMenu', className);
  const actionMenuListClass = c('actionMenu-list');
  const actionMenuItemClass = c('actionMenu-item', { 'icon': alignLeft });

  return (
    <Menu
      id="row-action-menu"
      anchorEl={anchorEl}
      open={Boolean(anchorEl)}
      onClose={handleClose}
      classes={{ paper: actionMenuClass, list: actionMenuListClass }}
      style={style}
      anchorOrigin={
        type === 'selected'
          ? { vertical: 'top', horizontal: 'center' }
          : type === 'table'
            ? { vertical: 'top', horizontal: 'right' }
            : { vertical: 'bottom', horizontal: 'right' }
      }
      transformOrigin={
        type === 'selected'
          ? { vertical: 105, horizontal: 'center' }
          : type === 'table'
            ? { vertical: -40, horizontal: 195 }
            : { vertical: -4, horizontal: 'right' }
      }
      // transformOrigin={
      //   type === 'selected'
      //     ? { vertical: 105, horizontal: 'center' }
      //     : type === 'table'
      //       ? { vertical: -40, horizontal: 195 }
      //       : { vertical: -34, horizontal: 'right' }
      // }
    >
      {actions.map((item, i) => {

        return (
          <MenuItem
            key={i}
            disabled={item.disabled}
            className={actionMenuItemClass}
            onClick={() => { item.action(); handleClose(); }}
          >
            {item.icon}{item.title}
          </MenuItem>
        );
      })}
    </Menu>
  );
};

ActionMenu.propTypes = {
  anchorEl: PropTypes.any,
  actions: PropTypes.arrayOf(PropTypes.shape({
    icon: PropTypes.node,
    title: PropTypes.string.isRequired,
    action: PropTypes.func.isRequired
  })).isRequired,
  handleClose: PropTypes.func.isRequired,
  className: PropTypes.string,
  type: PropTypes.oneOf(['default', 'table', 'selected']),
  alignLeft: PropTypes.bool,
  style: PropTypes.object
};

export default ActionMenu;